/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropSlugResponse
 */
export interface DropSlugResponse {
    /**
     * 
     * @type {string}
     * @memberof DropSlugResponse
     */
    slug: string;
}

/**
 * Check if a given object implements the DropSlugResponse interface.
 */
export function instanceOfDropSlugResponse(value: object): value is DropSlugResponse {
    if (!('slug' in value) || value['slug'] === undefined) return false;
    return true;
}

export function DropSlugResponseFromJSON(json: any): DropSlugResponse {
    return DropSlugResponseFromJSONTyped(json, false);
}

export function DropSlugResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropSlugResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'slug': json['slug'],
    };
}

export function DropSlugResponseToJSON(json: any): DropSlugResponse {
    return DropSlugResponseToJSONTyped(json, false);
}

export function DropSlugResponseToJSONTyped(value?: DropSlugResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'slug': value['slug'],
    };
}

